export default "/15ae7815822550b80ad7bc583daed9d5.jpg";